module.exports = __webpack_public_path__ + "img/11_101.005173f4.png";